import { render, staticRenderFns } from "./general_report.vue?vue&type=template&id=439ff084&"
import script from "./general_report.vue?vue&type=script&lang=js&"
export * from "./general_report.vue?vue&type=script&lang=js&"
import style0 from "./general_report.vue?vue&type=style&index=0&id=439ff084&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports